import React, { useEffect, useState } from "react"
import { Box, BoxProps, Button, Flex, Text, useBreakpointValue } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import "swiper/css/navigation"

import ProductSiblingSelectorButton from "@app/components/Product/ProductSiblingSelectorButton"
import Icon from "@app/components/Icon"

type Props = {
  siblings: any
  activeSibling: any
  resetActiveSibling: () => void
  setActiveSibling: (sibling: any) => void
} & BoxProps

const ProductSiblingSelector: React.FC<Props> = ({ siblings, activeSibling, setActiveSibling, resetActiveSibling, ...props }) => {
  const [isSwiperReady, setSwiperReady] = useState(false)
  const slidesPerView = useBreakpointValue({ base: 4, sm: 7, lg: 6 }) || 6

  useEffect(() => {
    resetActiveSibling()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return siblings?.length > 1 ? (
    <Box {...props} height={{ base: "auto" }} position="relative" width="100%">
      <Flex justify="space-between" alignItems="center">
        <Text variant="text14" visibility={activeSibling?.colorTitle ? "visible" : "hidden"}>
          {activeSibling?.colorTitle || "-"}
        </Text>
        <Flex display={siblings.length > slidesPerView ? "flex" : "none"}>
          <Button
            display="flex"
            variant="unstyled"
            aria-label="Previous Slide"
            title="Previous Slide"
            className="swiper-button-sibling-prev"
          >
            <Icon name="chevronLeft" width="8px" height="auto" pointerEvents="none" />
          </Button>
          <Button display="flex" variant="unstyled" aria-label="Next Slide" title="Next Slide" className="swiper-button-sibling-next">
            <Icon name="chevronRight" width="8px" height="auto" pointerEvents="none" />
          </Button>
        </Flex>
      </Flex>
      <Box
        onMouseLeave={resetActiveSibling}
        overflow={{ base: "visible", sm: "hidden" }}
        sx={{
          ".swiper": {
            py: "4px",
          },
          ".swiper-slide": {
            opacity: "0",
          },
          ".swiper-slide-visible": {
            opacity: "1",
          },
        }}
        maxWidth={{ base: "100%", md: "646px", lg: "100%" }}
      >
        <Swiper
          style={{
            transition: "opacity 1s",
            opacity: isSwiperReady ? 1 : 0,
          }}
          navigation={{
            nextEl: ".swiper-button-sibling-next",
            prevEl: ".swiper-button-sibling-prev",
            disabledClass: "swiper-disabled",
          }}
          modules={[Navigation]}
          onInit={() => {
            setSwiperReady(true)
          }}
          slidesPerView={slidesPerView}
          spaceBetween={12}
          watchSlidesProgress={true}
        >
          {siblings?.map((sibling: any) => (
            <SwiperSlide key={sibling?.id}>
              <ProductSiblingSelectorButton
                sibling={sibling}
                activeSibling={activeSibling}
                handleMouseEnter={sibling => setActiveSibling(sibling)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  ) : null
}

export default React.memo(ProductSiblingSelector)
